const FUNDER_PROFILE_EN = Object.freeze({
    'funder-profile.title': 'Funder Profile',
    'funder-profile.institutional': 'Institutional',
    'funder-profile.individual': 'Individual',
    'funder-profile.funder-name': 'Funder Name',
    'funder-profile.br-number': 'BR Number',
    'funder-profile.location': 'Country / Region',
    'funder-profile.phone': 'Phone',
    'funder-profile.id-type': 'ID Type',
    'funder-profile.id-number': 'ID Number',
    'funder-profile.street-address': 'Street Address',
    'funder-profile.city': 'City',
    'funder-profile.states': 'States / District',
    'funder-profile.postcode': 'Postal Code',
    'funder-profile.initial-contact-person': 'Initial Contact Person',
    'funder-profile.first-name': 'First Name',
    'funder-profile.last-name': 'Last Name',
    'funder-profile.position': 'Position',
    'funder-profile.edit': 'Edit',
    'funder-profile.back': 'Back',
    'funder-profile.next': 'Next',
    'funder-profile.user-credential': 'User Credential',
    'funder-profile.phone-country-code': 'Phone Code',
    'funder-profile.update-password-caption': 'For security reason, you cannot change your email manually. Please contact Qupital to amend the email address.',
    'funder-profile.update-profile-caption': 'For security reason, we disable the profile editing by default. If you need to make change of your account, please contact Qupital.',
    'funder-profile.update-profile-title': 'Why I cannot edit the Profile?',
    'funder-profile.profile-tab-title': 'Funder Profile',
    'funder-profile.password-tab-title': 'Account Settings',
    'funder-profile.password-updated': 'Update password successfully',
    'funder-profile.password-failed': 'Fail to update password',
    'funder-profile.funder-name.warning': 'Please Input Funder Name',
    'funder-profile.br-number.warning': 'Please Input BR Number',
    'funder-profile.location.warning': 'Please Input Location / Region',
    'funder-profile.phone.warning': 'Please Input Phone',
    'funder-profile.id-type.warning': 'Please Input ID Type',
    'funder-profile.id-number.warning': 'Please Input ID Number',
    'funder-profile.street-address.warning': 'Please Input Street Address',
    'funder-profile.city.warning': 'Please Input City',
    'funder-profile.states.warning': 'Please Input States / District',
    'funder-profile.postcode.warning': 'Please Input Postal Code',
    'funder-profile.initial-contact-person.warning': 'Please Input Initial Contact Person',
    'funder-profile.first-name.warning': 'Please Input First Name',
    'funder-profile.last-name.warning': 'Please Input Last Name',
    'funder-profile.position.warning': 'Please Input Position',
    'funder-profile.qupital-parameter.title': 'Qupital Funder',
    'funder-profile.qupital-parameter.funder-number': 'Funder Number',
    'funder-profile.isEdit': 'Edit Profile',
    'funder-profile.active': 'Activate my account',
    'funder-profile.submit-for-review': 'Submit for Review',
    'funder-applicant.edit-caption': 'Once you update the profile, Qupital will to review the modifications. You will be notified when your account is ready.',
    'funder-applicant.edit-caption-title': 'Need to update the Profile?',
    'funder-profile.id-type.hkid': 'Hong Kong Identity Card',
    'funder-profile.id-type.passport': 'Passport',
    'activate-account.title': "Reset Password",
    'funder-registration.title.reset-password': "Reset Password",
    'funder-registration.title.review-information': "Review Information",
    'funder-registration.title.done': 'Done',
    'funder-registration.title.review': 'Review',
    'funder-registration.review-title': 'Almost There!',
    'funder-registration.review-caption': 'Your account profile is updated. Qupital is reviewing your modification. Please stay turn and we will get you back soon.',
    'funder-registration.button.proceed-to-marketplace': 'Proceed to Marketplace',
    'funder-registration.done-caption': 'Your account is now activated. You can proceed to marketplace to purchase your desirable assets. A gentle reminder that you should make a meticulous consideration before making purchase decision.',
    'funder-registration.done-title': 'You did it!',
    'funder-applicant.layout-header.path': 'Home / Account Activation',
    'funder-applicant.layout-header.caption': 'Please review and activation before proceeding to marketplace',
    'funder-profile.title.funder-information': 'Funder Information',
    'funder-profile.notice': 'Notice',
});

const FUNDER_PROFILE_ZH_TW = Object.freeze({
    'funder-profile.title': '投資者資料',
    'funder-profile.institutional': '機構投資',
    'funder-profile.individual': '個人投資者',
    'funder-profile.funder-name': '投資者名稱',
    'funder-profile.br-number': '商業登記證編號',
    'funder-profile.location': '國家 / 地區',
    'funder-profile.phone': '電話號碼',
    'funder-profile.id-type': '證件類別',
    'funder-profile.id-number': '證件號碼',
    'funder-profile.street-address': '街道地址',
    'funder-profile.city': '城市',
    'funder-profile.states': '州 / 區',
    'funder-profile.postcode': '郵遞區號',
    'funder-profile.initial-contact-person': '聯絡人',
    'funder-profile.first-name': '名字',
    'funder-profile.last-name': '姓氏',
    'funder-profile.position': '職位',
    'funder-profile.edit': '更改',
    'funder-profile.back': '返回',
    'funder-profile.next': '繼續',
    'funder-profile.user-credential': '用戶憑證',
    'funder-profile.phone-country-code': '電話區號',
    'funder-profile.update-password-caption': '基於保安理由, 您不能自行更改您的登入電郵。請聯絡橋彼道進行更新。',
    'funder-profile.update-profile-caption': '基於保安理由, 您不能自行更改投資者資料。請聯絡橋彼道進行更新。',
    'funder-profile.update-profile-title': '為什麼我不能更改投資者資料?',
    'funder-profile.profile-tab-title': '投資者資料',
    'funder-profile.password-tab-title': '設定',
    'funder-profile.password-updated': '已成功更改密碼',
    'funder-profile.password-failed': '更新密碼失敗',
    'funder-profile.funder-name.warning': '請輸入投資者名稱',
    'funder-profile.br-number.warning': '請輸入商業登記證編號',
    'funder-profile.location.warning': '請輸入國家 / 地區',
    'funder-profile.phone.warning': '請輸入電話號碼',
    'funder-profile.id-type.warning': '請輸入證件類別',
    'funder-profile.id-number.warning': '請輸入證件號碼',
    'funder-profile.street-address.warning': '請輸入街道地址',
    'funder-profile.city.warning': '請輸入城市',
    'funder-profile.states.warning': '請輸入州 / 區',
    'funder-profile.postcode.warning': '請輸入郵遞區號',
    'funder-profile.initial-contact-person.warning': '請輸入聯絡人',
    'funder-profile.first-name.warning': '請輸入名字',
    'funder-profile.last-name.warning': '請輸入姓氏',
    'funder-profile.position.warning': '請輸入職位',
    'funder-profile.qupital-parameter.title': '橋彼道投資者參數',
    'funder-profile.qupital-parameter.funder-number': '投資者編號',
    'funder-profile.isEdit': '更改投資者資料',
    'funder-profile.active': '激活我的帳戶',
    'funder-profile.submit-for-review': '提交覆核',
    'funder-applicant.edit-caption': '當您提交覆核後, 橋彼道將會再次覆核已更新的資料。當準備就緒時，我們將會通知您',
    'funder-applicant.edit-caption-title': '需要更新投資者資料?',
    'funder-profile.id-type.hkid': '香港身份證',
    'funder-profile.id-type.passport': '護照',
    'activate-account.title': "重置密碼",
    'funder-registration.title.reset-password': "重置密碼",
    'funder-registration.title.review-information': "提交以供覆核",
    'funder-registration.title.done': '完成',
    'funder-registration.title.review': '覆核',
    'funder-registration.review-title': '即將完成!',
    'funder-registration.review-caption': '您的帳戶已更新. 橋彼道正在覆核您的更新。我們會盡快通知您的結果。',
    'funder-registration.button.proceed-to-marketplace': '進入市場',
    'funder-registration.done-caption': '您的帳戶已被啟用. 您現在可以進入市場購買不同資產。溫馨提示: 請經過慎重考慮後才購買資產。',
    'funder-registration.done-title': '帳戶已被啟用!',
    'funder-applicant.layout-header.path': '首頁 / 啟用帳戶',
    'funder-applicant.layout-header.caption': '進入市場前，請先覆核並啟用帳戶。',
    'funder-profile.title.funder-information': '投資者資料',
    'funder-profile.notice': '通告',
});


export {
    FUNDER_PROFILE_EN,
    FUNDER_PROFILE_ZH_TW
}